var React = require('react');

function ProfileInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 21a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM12.5 30c1.424-2.974 4.249-5 7.5-5 3.251 0 6.076 2.026 7.5 5","stroke":"#333","strokeWidth":"2"}));
}

ProfileInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = ProfileInline;

ProfileInline.default = ProfileInline;
